export { default } from './AccordionDetails';
export { default as accordionDetailsClasses } from './accordionDetailsClasses';
export * from './accordionDetailsClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/AccordionDetails/index.js
// module id = 879
// module chunks = 25